export function importIntlDateTimeFormatLocaleData(locale: string) {
  switch (locale) {
    case 'de':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/de' /* webpackChunkName: 'intl-datetimeformat-locale-data-de' */
      );

    case 'ja':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/ja' /* webpackChunkName: 'intl-datetimeformat-locale-data-ja' */
      );

    case 'es':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/es' /* webpackChunkName: 'intl-datetimeformat-locale-data-es' */
      );

    case 'es-mx':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/es-MX' /* webpackChunkName: 'intl-datetimeformat-locale-data-es-MX' */
      );

    case 'id':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/id' /* webpackChunkName: 'intl-datetimeformat-locale-data-id' */
      );

    case 'ko':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/ko' /* webpackChunkName: 'intl-datetimeformat-locale-data-ko' */
      );

    case 'ms':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/ms' /* webpackChunkName: 'intl-datetimeformat-locale-data-ms' */
      );

    case 'ru':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/ru' /* webpackChunkName: 'intl-datetimeformat-locale-data-ru' */
      );

    case 'th':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/th' /* webpackChunkName: 'intl-datetimeformat-locale-data-th' */
      );

    case 'tr':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/tr' /* webpackChunkName: 'intl-datetimeformat-locale-data-tr' */
      );

    case 'uk':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/uk' /* webpackChunkName: 'intl-datetimeformat-locale-data-uk' */
      );

    case 'vi':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/vi' /* webpackChunkName: 'intl-datetimeformat-locale-data-vi' */
      );

    case 'da':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/da' /* webpackChunkName: 'intl-datetimeformat-locale-data-da' */
      );

    case 'fr':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/fr' /* webpackChunkName: 'intl-datetimeformat-locale-data-fr' */
      );

    case 'it':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/it' /* webpackChunkName: 'intl-datetimeformat-locale-data-it' */
      );

    case 'nl':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/nl' /* webpackChunkName: 'intl-datetimeformat-locale-data-nl' */
      );

    case 'pl':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/pl' /* webpackChunkName: 'intl-datetimeformat-locale-data-pl' */
      );

    case 'pt':
    case 'pt-br':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/pt' /* webpackChunkName: 'intl-datetimeformat-locale-data-pt' */
      );

    case 'sv':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/sv' /* webpackChunkName: 'intl-datetimeformat-locale-data-sv' */
      );

    case 'fi':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/fi' /* webpackChunkName: 'intl-datetimeformat-locale-data-fi' */
      );

    case 'cs':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/cs' /* webpackChunkName: 'intl-datetimeformat-locale-data-cs' */
      );

    case 'bg':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/bg' /* webpackChunkName: 'intl-datetimeformat-locale-data-bg' */
      );

    case 'ca':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/ca' /* webpackChunkName: 'intl-datetimeformat-locale-data-ca' */
      );

    case 'hr':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/hr' /* webpackChunkName: 'intl-datetimeformat-locale-data-hr' */
      );

    case 'et':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/et' /* webpackChunkName: 'intl-datetimeformat-locale-data-et' */
      );

    case 'el':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/el' /* webpackChunkName: 'intl-datetimeformat-locale-data-el' */
      );

    case 'hu':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/hu' /* webpackChunkName: 'intl-datetimeformat-locale-data-hu' */
      );

    case 'lv':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/lv' /* webpackChunkName: 'intl-datetimeformat-locale-data-lv' */
      );

    case 'lt':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/lt' /* webpackChunkName: 'intl-datetimeformat-locale-data-lt' */
      );

    case 'ro':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/ro' /* webpackChunkName: 'intl-datetimeformat-locale-data-ro' */
      );

    case 'sr':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/sr' /* webpackChunkName: 'intl-datetimeformat-locale-data-sr' */
      );

    case 'sk':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/sk' /* webpackChunkName: 'intl-datetimeformat-locale-data-sk' */
      );

    case 'sl':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/sl' /* webpackChunkName: 'intl-datetimeformat-locale-data-sl' */
      );

    case 'sw':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/sw' /* webpackChunkName: 'intl-datetimeformat-locale-data-sw' */
      );

    case 'is':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/is' /* webpackChunkName: 'intl-datetimeformat-locale-data-is' */
      );

    case 'fil':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/fil' /* webpackChunkName: 'intl-datetimeformat-locale-data-fil' */
      );

    case 'ar':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/ar' /* webpackChunkName: 'intl-datetimeformat-locale-data-ar' */
      );

    case 'he':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/he' /* webpackChunkName: 'intl-datetimeformat-locale-data-he' */
      );

    case 'mt':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/mt' /* webpackChunkName: 'intl-datetimeformat-locale-data-mt' */
      );

    case 'az':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/az' /* webpackChunkName: 'intl-datetimeformat-locale-data-az' */
      );

    case 'ka':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/ka' /* webpackChunkName: 'intl-datetimeformat-locale-data-ka' */
      );

    case 'gl':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/gl' /* webpackChunkName: 'intl-datetimeformat-locale-data-gl' */
      );

    case 'eu':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/eu' /* webpackChunkName: 'intl-datetimeformat-locale-data-eu' */
      );

    case 'fr-ca':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/fr-CA' /* webpackChunkName: 'intl-datetimeformat-locale-data-fr-CA' */
      );

    case 'zh-hant':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/zh-Hant' /* webpackChunkName: 'intl-datetimeformat-locale-data-zh-Hant' */
      );

    case 'zh-hans':
      return import(
        '@formatjs/intl-datetimeformat/locale-data/zh-Hans' /* webpackChunkName: 'intl-datetimeformat-locale-data-zh-Hans' */
      );

    case 'no':
      // Norwegian bokmål (nb) is the dominant language in Norway
      return import(
        '@formatjs/intl-datetimeformat/locale-data/nb' /* webpackChunkName: 'intl-datetimeformat-locale-data-nb' */
      );

    default:
      return import(
        '@formatjs/intl-datetimeformat/locale-data/en' /* webpackChunkName: 'intl-datetimeformat-locale-data-en' */
      );
  }
}
